import {Component, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';
import {RouteRenderer, RouteTimeline} from 'shared';
import {Subscription} from 'rxjs';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';

@Component({
  selector: 'app-tractors-history-details-grid',
  templateUrl: './tractors-history-details-grid.component.html',
  styleUrls: ['./tractors-history-details-grid.component.scss']
})
export class TractorsHistoryDetailsGridComponent implements OnInit, OnDestroy {

  @Input()
  renderer: RouteRenderer;
  private rendererSub: Subscription;

  ds: DataSource;
  store: ArrayStore;

  isLoading: boolean;

  constructor(public host: ElementRef) {
    this.store = new ArrayStore({
      key: 'id',
      data: [],
    });
    this.ds = new DataSource({
      paginate: false,
      store: this.store,
    });
  }

  ngOnInit(): void {
    this.rendererSub = this.renderer.loading$.subscribe(isLoading => {
      this.isLoading = isLoading;
      if (isLoading) {
        this.clean();
      } else {
        this.build();
      }
    });
  }

  ngOnDestroy(): void {
    this.rendererSub.unsubscribe();
  }

  private clean() {
    this.store.clear();
  }

  private build() {
    this.renderer.routeTimeline.tags.map(t => {
      this.store.insert(t.gridRow());
    });
    this.ds.reload();
  }

  historyPathDetailsClicked(e: any) {
    this.renderer.routeTimeline.flyToTag(e.selectedRowsData[0].tag);
  }
}
